import Onboarding from "@/components/ui/onboarding";
import { useRouter } from "expo-router";
import React from "react";

export default function OnboardingIndex() {
  const router = useRouter();

  const handleNext = () => {
    router.push("/onboarding/location");
  };

  return (
    <Onboarding
      title="Get Help Fast"
      description="Request vehicle recovery, transport or roadside assistance in just a few steps."
      onButtonPress={handleNext}
      image={require("@/assets/images/onboarding/recovery.png")}
      step={1}
      totalSteps={3}
    />
  );
}
